import React from "react";

interface TableFooterProps {
  isMobile: boolean;
  totalItems: number;
  label: string;
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  indexOfFirstItem: number;
  indexOfLastItem: number;
  showAll: boolean;
  onToggleShowAll: () => void;
  onPageChange: (page: number) => void;
  className?: string;
}

const TableFooter: React.FC<TableFooterProps> = ({
  isMobile,
  totalItems,
  label,
  itemsPerPage,
  currentPage,
  totalPages,
  indexOfFirstItem,
  indexOfLastItem,
  showAll,
  onToggleShowAll,
  onPageChange,
  className = "",
}) => {
  return (
    <div
      className={`d-flex justify-content-between align-items-center flex-wrap ${
        isMobile ? "gap-2" : ""
      } ${className}`.trim()}
    >
      <div className="d-flex align-items-center gap-3">
        <small>
          {showAll
            ? `All ${totalItems} ${label}`
            : totalItems === 0
              ? `0 ${label}`
              : `${indexOfFirstItem + 1}–${Math.min(
                  indexOfLastItem,
                  totalItems,
                )} of ${totalItems} ${label}`}
        </small>
        {totalItems > itemsPerPage && (
          <h6 className="mb-0 cursor-pointer" onClick={onToggleShowAll}>
            {showAll ? `Show ${itemsPerPage} out of ${totalItems}` : "Show All"}
          </h6>
        )}
      </div>

      {!showAll && totalPages > 0 && (
        <div className="pagination">
          <button
            className="pagination-arrow"
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            <i className="fa-solid fa-angle-left"></i>
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={`pagination-page ${
                currentPage === i + 1 ? "active" : ""
              }`}
              onClick={() => onPageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="pagination-arrow"
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => onPageChange(currentPage + 1)}
          >
            <i className="fa-solid fa-angle-right"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default TableFooter;
